export default __webpack_public_path__ + "static/media/flag-icon.ce1a6a04.svg";